module.exports = __webpack_public_path__ + "static/media/Agri-Storage Entrepreneur Infographic Desktop - GBR Tech - 24-05-2024 C.3099dc25.gif";